import {createValidationForSchema} from '../../utils/ajvValidation'
import {validate as powtoonValidate} from '../../utils/powtoonValidation'
import schema from './schema/01.14.schema.json'
import {isDecimalInteger} from 'powtoon-commons/utils/numbers'
import {isVoiceoverItem} from 'powtoon-document'
import {calcDocumentDuration, roundToSupportedPrecision} from 'powtoon-document/utils/duration'
import {getManifestItemForDocItem} from 'powtoon-document/manifest'

let ajvValidate = null

export function initValidate ()  {
  if (!ajvValidate){
    ajvValidate = createValidationForSchema(schema)
  }
}

export const validate = async (powtoon,
  {
    strictMode = false,
    ignoreManifest = false,
    isValidTime = isDecimalInteger,
    getMinTimeStep,
    ignoreRichText = false
  } = {}) => {
  const powtoonValidationErrors = powtoonValidate(powtoon, {
    strictMode, ignoreManifest, isValidTime, getMinTimeStep, ignoreRichText
  })

  let powtoonForAjv = powtoon
  if (ignoreManifest) {
    powtoonForAjv = {...powtoon}
    delete(powtoonForAjv.manifest)
  }
  if (!ajvValidate){
    initValidate()
  }
  const ajvValidationErrors = ajvValidate (powtoonForAjv)

  if (!powtoonValidationErrors) {
    return ajvValidationErrors
  }

  if (!ajvValidationErrors) {
    return powtoonValidationErrors
  }

  return {
    errors: [...powtoonValidationErrors.errors, ...ajvValidationErrors.errors],
    // eslint-disable-next-line max-len
    errorMessage: `POWTOON VALIDATION:\n-------------------\n\n${powtoonValidationErrors.errorMessage}\n\nSCHEMA VALIDATION:\n------------------\n\n${ajvValidationErrors.errorMessage}`
  }
}

export function updatePowtoonContent(content) {
  // update powtoon content designed in a way to be executed only 1 or 0 time in every powtoon lifecycle
  // it powtoon content version is >= specific function version - this function will never run
  // here we should add missing fields to the powtoon document
  // later steps :
  // validate : we detect the missing asset in manifest , find wrong data and types
  // recovery : will try to fix all that is broken or missing including the manifest
  // part of the recovery will replace and update manifest using api call with all  manifest ids form server
  // this time we will :
  // * add startTime and endTime to document root audio tracks
  const documentDuration = calcDocumentDuration(content.powtoon.slides)

  content.powtoon.audioTracks?.forEach((audioTrack, index) => {
    if (audioTrack) {
      if (!audioTrack.itemType) {
        content.powtoon.audioTracks[index] = null
        return
      }

      const {length} = getManifestItemForDocItem(content.powtoon.manifest, audioTrack)
      const isVoiceover = isVoiceoverItem(audioTrack)
      
      const endTime = isVoiceover ? Math.min(roundToSupportedPrecision(length), documentDuration) : documentDuration
      audioTrack.startTime = 0
      audioTrack.endTime = endTime
      audioTrack.playbackSettings.endTime = roundToSupportedPrecision(length)
    }
  })
}